import {
  Bell,
  Briefcase,
  ClipboardCheck,
  Clock,
  CreditCard,
  Cuboid,
  FolderOpen,
  Link2,
  List,
  ListTodo,
  Mail,
  Play,
  Rss,
  UserCircle,
  Users,
} from 'lucide-react';
import type { SettingsNavItem } from '~/components/settings/SettingsNav';

export function getSettingsNavItems({
  canEditUsers,
  canEditFileAccess,
  canEditBrands,
  canSyncEnvironments,
  canViewAuditLogs,
  canViewReviewQueues,
  canViewClaimsApproval,
  canViewRemediation,
  canViewSharedLinks,
  canViewInfluencerMonitoring,
  canViewCommunicationReview,
  isEnterprise,
  workspaceId,
}: {
  canEditBrands: boolean;
  canSyncEnvironments: boolean;
  canEditUsers: boolean;
  canEditFileAccess: boolean;
  canViewAuditLogs: boolean;
  canViewReviewQueues: boolean;
  canViewClaimsApproval: boolean;
  canViewRemediation: boolean;
  canViewSharedLinks: boolean;
  canViewInfluencerMonitoring: boolean;
  canViewCommunicationReview: boolean;
  isEnterprise: boolean;
  workspaceId: string;
}): SettingsNavItem[] {
  return [
    {
      icon: UserCircle,
      label: 'Profile',
      href: `/${workspaceId}/settings/profile`,
    },
    ...(!isEnterprise
      ? [
          {
            icon: CreditCard,
            label: 'Billing',
            href: `/${workspaceId}/settings/billing`,
          },
        ]
      : []),
    ...(isEnterprise
      ? [
          {
            icon: Play,
            label: 'Actions History',
            href: `/${workspaceId}/settings/actions-history`,
          },
        ]
      : []),
    ...(canEditBrands && isEnterprise
      ? [
          {
            icon: Briefcase,
            label: 'Brands',
            href: `/${workspaceId}/settings/brands`,
          },
        ]
      : []),
    ...(canEditFileAccess && isEnterprise
      ? [
          {
            icon: FolderOpen,
            label: 'File Access',
            href: `/${workspaceId}/settings/file-access`,
          },
        ]
      : []),
    ...(canViewReviewQueues
      ? [
          {
            icon: List,
            label: 'Review Queues',
            href: `/${workspaceId}/settings/review-queues`,
          },
        ]
      : []),
    ...(canViewInfluencerMonitoring
      ? [
          {
            icon: Rss,
            label: 'Influencer Monitoring',
            href: `/${workspaceId}/settings/influencer-monitoring`,
          },
        ]
      : []),
    ...(canViewCommunicationReview
      ? [
          {
            icon: Mail,
            label: 'Communication Review',
            href: `/${workspaceId}/settings/communication-review`,
          },
        ]
      : []),
    ...(canViewClaimsApproval
      ? [
          {
            icon: ClipboardCheck,
            label: 'Claims Approval',
            href: `/${workspaceId}/settings/claims-approval`,
          },
        ]
      : []),
    ...(canViewRemediation
      ? [
          {
            icon: ListTodo,
            label: 'Remediation',
            href: `/${workspaceId}/settings/remediation`,
          },
        ]
      : []),
    ...(canEditUsers
      ? [
          {
            icon: Users,
            label: 'Users',
            href: `/${workspaceId}/settings/users`,
          },
        ]
      : []),
    ...(canViewAuditLogs && isEnterprise
      ? [
          {
            icon: Clock,
            label: 'Audit Logs',
            href: `/${workspaceId}/settings/logs`,
          },
        ]
      : []),
    ...(canSyncEnvironments && isEnterprise
      ? [
          {
            icon: Cuboid,
            label: 'Environments',
            href: `/${workspaceId}/settings/environments`,
          },
        ]
      : []),
    ...(isEnterprise
      ? [
          {
            icon: Bell,
            label: 'Notifications',
            href: `/${workspaceId}/settings/notifications`,
          },
        ]
      : []),
    ...(canViewSharedLinks
      ? [
          {
            icon: Link2,
            label: 'Shared Links',
            href: `/${workspaceId}/settings/shared-links`,
          },
        ]
      : []),
  ] as SettingsNavItem[];
}
